import type { Ref } from 'vue'
import { toRef } from 'vue'
import type { RemovableRef } from '@vueuse/core'
import { useStorage } from '@vueuse/core'

let cache: RemovableRef<Record<string, any>>
export function useCache<T>(key: string, defaultValue?: T) {
  cache = cache || useStorage('thesis-platform', {} as Record<string, any>)
  if (
    cache.value[key] === undefined
    || (defaultValue != null && typeof cache.value[key] !== typeof defaultValue)
  ) {
    cache.value[key] = defaultValue
  }
  return toRef(cache.value, key) as Ref<T>
}
